module.exports = __webpack_public_path__ + "img/pr-10.1a65ce68.png";